import { useTranslation } from 'react-i18next';
import { type Tour } from '@/api/types';
import { centsToUsdString } from '@/utils/money';
import { useLocale } from '@/hooks/useLocale';
import styles from './TourCard.module.css';

interface TourCardProps {
  tour: Tour;
  onClick?: () => void;
}

export function TourCard({ tour, onClick }: TourCardProps): JSX.Element {
  const { t } = useTranslation();
  const { locale } = useLocale();
  const perUnitKey =
    tour.per_unit === 'per_night'
      ? 'travel.tour.per_night'
      : tour.per_unit === 'per_person'
        ? 'travel.tour.per_person'
        : 'travel.tour.total';
  return (
    <article className={styles.card} onClick={onClick} role="button">
      {tour.cover_image_url && (
        <div className={styles.cover} style={{ backgroundImage: `url(${tour.cover_image_url})` }} aria-hidden />
      )}
      <div className={styles.body}>
        <h3 className={styles.title}>{tour.title}</h3>
        {tour.city_name && <div className={styles.city}>{tour.city_name}, {tour.country_code}</div>}
        <div className={styles.meta}>
          {tour.nights && <span>{t('travel.tour.nights', { count: tour.nights })}</span>}
          {tour.days && <span>{t('travel.tour.days', { count: tour.days })}</span>}
          {!!tour.rating && <span>★ {tour.rating.toFixed(1)}</span>}
        </div>
        <div className={styles.priceRow}>
          <span className={styles.price}>
            {t('travel.tour.from', { price: centsToUsdString(tour.from_price_cents, locale) })}
          </span>
          <span className={styles.priceUnit}>{t(perUnitKey)}</span>
        </div>
      </div>
    </article>
  );
}
